export var BoutonRadioDefaultProps = {
    name: '',
    value: '',
    label: '',
    disabled: false,
    texteAide: undefined,
    taille: undefined,
    required: false,
};
